export const GET_ROLEPERMISSION = "GET_ROLEPERMISSION";
export const ALL_ROLEPERMISSION = "ALL_ROLEPERMISSION";
export const EDIT_ROLEPERMISSION = "EDIT_ROLEPERMISSION";




